import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-black" role="status" aria-label="Validando sesión"><div className="h-8 w-8 animate-spin rounded-full border-b-2 border-[var(--upim-acento)]" /></div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.must_change_password && location.pathname !== '/cuenta/seguridad') return <Navigate to="/cuenta/seguridad" replace />;
  return children;
}
